import { httpClient } from './httpClient'
import type {
  CreateFolderRequest,
  FolderContents,
  FolderDto,
  ScanSortMode
} from '@/models/library'

export const foldersApi = {
  async tree(): Promise<FolderDto[]> {
    const { data } = await httpClient.get<FolderDto[]>('/api/folders')
    return data
  },

  async contents(folderId: string | null): Promise<FolderContents> {
    const url = folderId ? `/api/folders/${folderId}/contents` : '/api/folders/root/contents'
    const { data } = await httpClient.get<FolderContents>(url)
    return data
  },

  async create(request: CreateFolderRequest): Promise<FolderDto> {
    const { data } = await httpClient.post<FolderDto>('/api/folders', request)
    return data
  },

  async rename(id: string, name: string): Promise<FolderDto> {
    const { data } = await httpClient.put<FolderDto>(`/api/folders/${id}`, { name })
    return data
  },

  async move(id: string, parentId: string | null): Promise<FolderDto> {
    const { data } = await httpClient.post<FolderDto>(`/api/folders/${id}/move`, { parentId })
    return data
  },

  async setSort(id: string, sortMode: ScanSortMode): Promise<FolderDto> {
    const { data } = await httpClient.put<FolderDto>(`/api/folders/${id}/sort`, { sortMode })
    return data
  },

  async remove(id: string): Promise<void> {
    await httpClient.delete(`/api/folders/${id}`)
  }
}
